<template>
    <svg viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.80268 12.4998L1.3999 8.99976M1.3999 8.99976L4.80268 5.49976M1.3999 8.99976L9.7999 8.99976M12.5996 3.39985V14.5999" stroke="#060606" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.3193 14V4.00586H20.9531V12.5986H25.1846V14H19.3193Z" fill="#060606"/>
    </svg>
</template>